@if (
  {
    allLenses: allLenses$ | async
  };
  as state
) {
  <lenses-header (searchValueChange)="searchValue$.next($event)" [allLenses]="state.allLenses"></lenses-header>
  <lenses-table [allLenses]="state.allLenses" [searchValue$]="searchValue$"></lenses-table>
} @else {
  <div class="oph-loading-container">
    <oph-loading />
  </div>
}
